import { SCREEN } from '@atlassian/jira-product-analytics-bridge';

export const getSpotlightAnalyticsContextData = (spotlightKind: string) => ({
	sourceName: 'onboardingSpotlight',
	sourceType: SCREEN,
	attributes: { spotlightKind },
});
